export default function(h, row, index) {
    let _s1 = ''
    if (row.team_id) {
        _s1 =  'Группа: '+  row.team.title;
        return <span>{_s1}</span>
    }

    if (row.assignee_id && row.assignee) {
        //_s1 =  '#' + row.assignee_id + ': ' +  row.assignee_firstname + ' ' + row.assignee_lastname + ' (' + row.assignee_login + ')';
        _s1 =  row.assignee.name_ + ' ' + row.assignee.patro   + ' ' + row.assignee.surname ;
        return <span>{_s1}</span>
    }

    return ''
}
